import React, { useState, useEffect } from 'react';
import {firestore, storage, arrayUnion} from '../firebase';

var ProfileStateContext = React.createContext();
var ProfileDispatchContext = React.createContext();
var ProfileContext = React.createContext();

function ProfileReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function ProfileProvider({ children }) {
  const [currentProfile, setCurrentProfile] = useState(null);
  const [userInformation, setUserInformation] = useState(null);
  const [files, setFiles] = useState(null);

  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    if(currentProfile && localStorage.getItem('user_uid')) {
      setLoading(true);
      localStorage.setItem('currentProfile', currentProfile);
      getProfile(currentProfile).then((profileList) => {
        let filesArray = [];
        if (profileList.fileSystem){
          profileList.fileSystem.forEach((fileName) => {
            filesArray.push(fileName)
          })
        }
        setFiles(filesArray);
        setUserInformation(profileList);
        setLoading(false);
      });
    } else if (localStorage.getItem('currentProfile') && localStorage.getItem('user_uid')) {
      setLoading(true);
      getProfile(localStorage.getItem('currentProfile')).then((profileList) => {
        let filesArray = [];
        if (profileList.fileSystem){
          profileList.fileSystem.forEach((fileName) => {
            filesArray.push(fileName);
          })
        }
        setFiles(filesArray);
        setUserInformation(profileList);
        setLoading(false);
      });
    }
  }, [currentProfile]);

  
  var [state, dispatch] = React.useReducer(ProfileReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <ProfileStateContext.Provider value={state}>
      <ProfileDispatchContext.Provider value={dispatch}>
        <ProfileContext.Provider value={{setCurrentProfile, setUserInformation, userInformation, Loading, files, setFiles}}>
          {children}
        </ProfileContext.Provider>
      </ProfileDispatchContext.Provider>
    </ProfileStateContext.Provider>
  );
}

function useProfileState() {
  var context = React.useContext(ProfileStateContext);
  if (context === undefined) {
    throw new Error("useProfileState must be used within a ProfileProvider");
  }
  return context;
}

function useProfileDispatch() {
  var context = React.useContext(ProfileDispatchContext);
  if (context === undefined) {
    throw new Error("useProfileDispatch must be used within a ProfileProvider");
  }
  return context;
}

function useProfileContext() {
  var context = React.useContext(ProfileContext);

  if (context === undefined) {
    throw new Error("useProfileContext must be used within a ProfileProvider");
  }
  return context;
}

export { ProfileProvider, useProfileState, useProfileDispatch, useProfileContext, getProfile, addDashboardGrades, firebaseUpload };

// ###########################################################

function getProfile(currentProfile) {
  if(currentProfile) {
  return new Promise ((resolve, reject) => {
    firestore
      .collection('Users')
      .doc(currentProfile)
      .get()
      .then((snapshot) => {
        resolve(formatProfile(snapshot))
      })
      .catch((error) => reject(console.log(error)));
  });
  } else {
    console.log('no')
  }
}

function formatProfile(profileDoc) {
  const data = profileDoc.data();
  return{
    avatar: data.avatar,
    name: data.name,
    email: data.email,
    surveyCompleted: data.surveyCompleted,
    dashboardGrade: data.dashboardGrade,
    survey: data.survey,
    fileSystem: data.fileSystem,
  }
};

function addDashboardGrades(dashboardGrade, setProfile, Profile) {
  firestore
    .collection('Users')
    .doc(localStorage.getItem('currentProfile'))
    .update({
      dashboardGrade
    })
    .then(() => {
      console.log('it worked')
      setProfile.setUserInformation({...Profile, dashboardGrade: dashboardGrade})
    })
};

function firebaseUpload(file) {
  var storageRef = storage.ref().child(localStorage.getItem('currentProfile') + '/' + file.name)
  storageRef.put(file)
    .then(() =>{
      firestore
        .collection('Users')
        .doc(localStorage.getItem('currentProfile'))
        .update({
          fileSystem: arrayUnion.FieldValue.arrayUnion(file.name)
        })
        .then(() => {

        })

    });
};